import React from 'react';
import { getPageStaticProps } from 'lib/dato-request';
import { ContentBlock1 } from 'components/Esser/ContentBlock1';
import Hero from 'components/Esser/Hero';
import EsserGuide from 'components/Esser/EsserGuide';
import { ConversionPanel1 } from 'components/Esser/ConversionPanel1';
import SecondaryPageLayout from '@/components/ReusableUI/SecondaryPageLayout';

const Esser = ({ data }) => {
    const { page } = data;
    const { components, seo } = page;
    return (
        <SecondaryPageLayout page={page} components={[components[3], components[4]]}>
            <Hero
                heading={components[0].heading}
                subhead={components[0].subhead}
                ctalabel={components[0].ctalabel}
                ctalink={components[0].ctalink || '/docs/TAP INTO ESSER FUNDING - A Roadmap to Using ESSER Funds to Accelerate Math Recovery (2021).pdf'}
                img={components[0].featuredImage}
            />
            <ContentBlock1 />
            <ConversionPanel1
                heading={components[2].heading}
                ctalabel={components[2].ctalabel}
                ctalink={components[2].ctalink || '/docs/TAP INTO ESSER FUNDING - A Roadmap to Using ESSER Funds to Accelerate Math Recovery (2021).pdf'}
            />
            <EsserGuide />
        </SecondaryPageLayout>
    );
};

export async function getStaticProps() {
    return getPageStaticProps('ESSER');
}

export default Esser;
